import React, { useState, useEffect } from 'react';
import { Button, Input, message } from 'antd';
import { restApi } from '../../../apis';
import TrainerPofileDetailCreate from '../atoms/trainer_profile_detail_create';
import dayjs from 'dayjs';

const CreateNewTrainer = (props) => {
  const { setGModal, setLoading, loading, setReFresh, ...rest } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const [isRead, setRead] = useState(false);
  const [options, setOptions] = useState({
    isNotFull: true,
    current: -1,
    totalPage: 0,
    total: 0,
    // sorts: {
    //   selected: 'name',
    //   account_name: 'asc', //desc
    // },
    refresh: new Date(),
    centers: [
      // {
      //   value: null,
      //   label: `센터정보 없음`,
      // },
    ],
  });

  const [data, setData] = useState({
    carrier: null,
    centerIP: null,
    centerName: null,
    centerPhone: null,
    email: null,
    id: null,
    name: null,
    phone: null,
    photoKey: null,
    photoExt: null,
    photoPath: null,
    role: null,
    center_code: null,
  });

  // 센터 명 선텍시 코드도 같이 선택해야해서 기획 필요np;m
  // useEffect(() => {
  //   if (options.isNotFull) {
  //     // 로딩
  //     setLoading(true);
  //     // 데이터 가져오기
  //     (async (x) => {
  //       const params = {
  //         pageNum: options.current < 1 ? 1 : options.current,
  //         orderBy: 'center_name',
  //         sort: 'desc',
  //       };

  //       const response = await restApi.get(`/admin/center`, {
  //         params,
  //       });

  //       const payload = response?.data?.payload;
  //       console.log('---->', payload);
  //       if (payload) {
  //         setOptions((prev) => {
  //           let centers = prev?.centers;
  //           let i = 0;
  //           for (; i < payload?.center?.length; i++) {
  //             const item = payload.center[i];
  //             if (centers.findIndex((c) => c.value == item.center_id) < 0) {
  //               centers.push({
  //                 value: item.center_id,
  //                 label: item.center_name,
  //               });
  //             }
  //           }
  //           return {
  //             ...prev,
  //             isNotFull: payload.totalPage > prev.current,
  //             current: prev.current + 1,
  //             total: payload.totalCount,
  //             totalPage: payload.totalPage,
  //             centers: centers,
  //           };
  //         });
  //       }

  //       setLoading(false);
  //     })();

  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 5000);
  //   }
  // }, [options.current]);

  return (
    <div style={{ ...styles.container }}>
      {/*---------------------------------------------------------------------------------------------------- */}
      {contextHolder}
      {/*---------------------------------------------------------------------------------------------------- */}
      <TrainerPofileDetailCreate
        data={data}
        setData={setData}
        isRead={isRead}
        setRead={setRead}
        centers={options?.centers}
        getCenter={() => {
          setOptions((prev) => {
            return {
              ...prev,
              current: (prev?.isNotFull && prev?.current + 1) || prev?.current,
            };
          });
        }}
        {...props}
      />
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div style={{ ...styles.footer }}>
        <Button
          width={69}
          height={38}
          style={{
            //font
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.8rem',
            letterSpacing: 0.43,
          }}
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
          }}
        >
          {'취소'}
        </Button>
        <Button
          width={69}
          height={38}
          style={{
            marginLeft: '1rem',
            background: '#A8AAAE',
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
            borderRadius: '0.6rem',

            //font
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.8rem',
            letterSpacing: 0.43,
            color: '#FFFFFF',
          }}
          onClick={(e) => {
            (async () => {
              // console.log('-=-==>', data);
              let errorMsg = '트레이너를 등록하는데 실패하였습니다.[정보확인]';
              let isSave = true;
              if (data?.isChangePasword) {
                if (data?.password != data?.confirmPwd) {
                  isSave = false;
                  errorMsg = '패스워드를 확인해 주세요';
                }
              } else {
                isSave = false;
                errorMsg = '패스워드를 입력해 주세요';
              }

              if (!data?.name) {
                isSave = false;
                errorMsg = '이름 입력해 주세요';
              } else if (!data?.phone) {
                isSave = false;
                errorMsg = '전화번호 입력해 주세요';
              } else if (!data?.email) {
                isSave = false;
                errorMsg = '이메일 입력해 주세요';
              }
              if (isSave) {
                await restApi
                  .post('/admin/trainer', {
                    email: data?.email,
                    password: data?.password || undefined,
                    center_code: data?.center_code,
                    name: data?.name,
                    carrier: data?.carrier || 'N/A',
                    phone: data?.phone,
                    // 이미지
                    // photoKey: data?.photoKey,
                    // photoExt: data?.photoExt,
                    // photoPath: data?.photoPath,
                    file_id: data?.photoKey,
                  })
                  .then((res) => {
                    if (res?.data?.error) {
                      messageApi.error(
                        `[Error] ${
                          res.data.error ||
                          '트레이너를 등록하는데 실패하였습니다.'
                        }`
                      );
                      return res;
                    }
                    messageApi.info('트레이너를 등록하였습니다.');
                    return res;
                  })
                  .catch((e) => {
                    messageApi.error(
                      `[Error] ${e || '트레이너를 등록하는데 실패하였습니다.'}`
                    );
                  });

                setReFresh && setReFresh(new Date());
                setTimeout(() => {
                  setGModal((prev) => {
                    return {
                      ...prev,
                      show: false,
                    };
                  });
                }, [1000]);
              } else {
                messageApi.error(errorMsg);
              }
            })();
          }}
        >
          {'추가'}
        </Button>
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '80%',
    // height: '102.3rem',
    flexDirection: 'column',
    // justifyContents: 'space-between',
    // justifyContent: 'center',
    background: '#FFFFFF',
    boxshadow: '0px 5px 20px rgba(75, 70, 92, 0.4)',
    borderRadius: 6,
    paddingLeft: '3rem',
    paddingRight: '3rem',
  },
  footer: {
    display: 'flex',
    height: '5.8rem',
    justifyContent: 'flex-end',
    padding: '0px 24px 20px',
    marginTop: '2.4rem',
  },
};
export default CreateNewTrainer;
